import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, formatErr } from "./api";
import { inputCls, Field, SaveBar, TabCard, Toggle } from "./fields";

export default function AnnouncementTab({ content, token, onSaved, onUnauthorized }) {
  const [draft, setDraft] = useState(content.announcement);
  const [saving, setSaving] = useState(false);
  useEffect(() => setDraft(content.announcement), [content.announcement]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await axios.put(`${API}/content/announcement`, draft, authHeaders(token));
      onSaved(data);
      toast.success("Saved — live on the website now.");
    } catch (err) {
      if (err.response?.status === 401) return onUnauthorized();
      toast.error(formatErr(err, "Save failed. Try again."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <TabCard title="Announcement Bar" sub="A thin bar above the header on every page" testid="tab-announcement">
      <div className="grid gap-5">
        <div className="flex items-center gap-4">
          <Toggle checked={draft.enabled} onChange={(v) => setDraft({ ...draft, enabled: v })} testid="announcement-toggle" label="Show announcement bar" />
          <span className="text-sm text-mut">{draft.enabled ? "On — visible on all pages" : "Off"}</span>
        </div>
        <Field label="Text"><input value={draft.text} onChange={(e) => setDraft({ ...draft, text: e.target.value })} placeholder="e.g. Founding price ends soon — 3 Launch Kit slots left" data-testid="announcement-text" className={inputCls} /></Field>
        <Field label="Link" hint="Optional — the whole bar becomes clickable"><input value={draft.link} onChange={(e) => setDraft({ ...draft, link: e.target.value })} placeholder="https://…" data-testid="announcement-link-input" className={inputCls} /></Field>
      </div>
      <SaveBar onSave={save} saving={saving} lastSaved={content.saved_at?.announcement} testid="announcement-save" />
    </TabCard>
  );
}
